<template>
	<div class="msg-analysis-text" :class="{'msg-analysis-text-me' : msg.is_me == 1}" v-html="message"></div>
</template>

<script>
	import Emoji from '../../util/emoji.js'
	
	export default{
		name: 'MsgAnalysisText',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: ''
			}
		},
		methods:{
			// 格式化文本
			formatText(){
				if (this.msg.content == undefined || this.msg.content == ''){
				    return;
				}
				let emoji_array = this.msg.content.match(/(\[(.+?)\]|[\uE40C\uE412\uE409\uE40D\uE107\uE403\uE40E\uE41D\uE14C\uE312\uE112]+?)/g)
				let __message = this.msg.content;
				// 替换普通表情
				if (emoji_array != null){
					for (let i = 0;i<emoji_array.length;i++){
						let __message_temp = emoji_array[i]
						let emoji_pic = this.getEmojiImg(emoji_array[i].substring(1,emoji_array[i].length-1))
						if (emoji_pic != ''){
							__message_temp = '<img src="'+emoji_pic+'" style="width: 24px;height: 24px;">'
						}
						__message = __message.replace(emoji_array[i],__message_temp);
					}
				}
				this.message = this.rn_to_br(__message)
			},
			
			// 获取表情图片
			getEmojiImg(name){
				let path = '';
				for(let i in Emoji.emoji){
					if(name == Emoji.emoji[i]){
						path = Emoji.path + i + '.png'
						break
					}
				}
				return path
			},
			
			// 换行转换
			rn_to_br(strValue){
			    return strValue.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
			}
		},
		
		created() {
			this.formatText()
		}
	}
</script>

<style>
	.msg-analysis-text{
		font-size: 13px;
		line-height: 20px;
		background-color: #EEEEEE;
		padding: 8px;
		border-radius: 2px;
		position: relative;
	}
	.msg-analysis-text::before{
		content: '';
		display: block;
		background-color: #EEEEEE;
		width: 12px;
		height: 12px;
		position: absolute;
		top: 8px;
		left: -6px;
		transform: rotateZ(45deg);
	}
	.msg-analysis-text-me{
		background-color: #b2e281 !important;
		text-align: left;
	}
	.msg-analysis-text-me::before{
		background-color: #b2e281;
		right: -6px;
		left: unset;
	}
</style>
